import { Link, useSearchParams } from 'react-router';
import type { Store } from '../data/types';

/**
 * Canonical links to the store and district detail pages. Every card that
 * names a store or district should render these, so navigation to the
 * dedicated store/district views works the same everywhere.
 */

export function storePath(storeNumber: string): string {
  return `/stores/${encodeURIComponent(storeNumber.trim())}`;
}

export function districtPath(district: string): string {
  return `/districts/${encodeURIComponent(district.trim())}`;
}

export function StoreLink({ store }: { store: Store }) {
  return (
    <Link className="entity-link" to={storePath(store.storeNumber)}>
      {store.storeNumber} — {store.name}
    </Link>
  );
}

/** Renders nothing when the store has no district assigned. */
export function DistrictLink({ district }: { district: string }) {
  // A page filtered to one owner (?owner=, 2026-10-28) opens the district filtered the same way (QA 2026-10-28).
  const [params] = useSearchParams();
  const owner = (params.get('owner') ?? '').trim();
  const name = district.trim();
  if (!name) return null;
  return (
    <Link className="entity-link" to={owner ? `${districtPath(name)}?${new URLSearchParams({ owner })}` : districtPath(name)}>
      {name}
    </Link>
  );
}
